export const MODULE_NAME = 'BLOCK_DATES_MODULE';
